import messagingSlice, { MessagingSlice as AudienceMessagingSlice } from './messagingSlice'

export type MessagingSlice = AudienceMessagingSlice
export const messagingReducer = messagingSlice.reducer
export const messagingActions = messagingSlice.actions
export default messagingSlice
